import { useCommentStore } from './commentStore'
import { useTaskStore } from './taskStore'
import { useTimelineActivityStore } from './timelineActivityStore'
import { useEmailStore } from './emailStore'
import { useEmailTemplateStore } from './emailTemplateStore'

export async function reloadAllStores() {
  console.log('Reloading all stores...')

  // Clear all stores first
  await Promise.allSettled([
    useCommentStore().clear(),
    useTaskStore().clear(),
    useTimelineActivityStore().clear(),
    useEmailStore().clear(),
    useEmailTemplateStore().clear(),
    // add more as needed
  ])

  // Load all stores
  await Promise.allSettled([
    useCommentStore().load(true),
    useTaskStore().load(true),
    useTimelineActivityStore().load(true),
    useEmailStore().load(true),
    useEmailTemplateStore().load(true),
    // add more as needed
  ])

  console.log('All stores reloaded')
}
